export const AP_SURVEY_PLATFORM_KEYS: readonly number[] = [1, 6];

export type SessionDetailDigitalTool = {
    name: string;
};

export type SessionDetailResourceAppointment = {
    raKey: number;
    pKey: number;
    imKey: number;
    firstName: string;
    lastName: string;
    email: string;
    esKey: number;
    programCode: string;
    programTitle: string;
    resourceType: string;
    appointmentType: string;
    appointmentStatus: string;
    startDateTimeUtc: Date;
    endDateTimeUtc: Date;
    ceResourceAssignmentId: string;
    categoryName: string;
    taskName: string;
    mobilePhone: string;
};

export type AvailableCoachesResponse = {
    coaches: SessionDetailAvailableCoach[];
};

export type AssignedCoachesResponse = {
    coaches: SessionDetailAssignedCoach[];
};

export type SessionDetailAssignedCoach = {
    imKey: number;
    apPKey?: number;
    pKey: number;
    email: string;
    firstName: string;
    lastName: string;
    isPrimary: boolean;
    isProposed: boolean;
    paxImKey: number;
    paxEsiKey?: number;
    esKey: number;
};

export type UpdateProductSaleSessionRequest = {
    esKey: number;
    eventTitle: string | null;
    clientName: string | null;
};

export type SessionDetailAvailableCoach = {
    imKey: number;
    pKey: number;
    email: string;
    firstName: string;
    lastName: string;
};

export type SessionDetailType = {
    title: string;
    customer: string;
    projectManager: string;
    projectManagerEmail: string;
    accountManager: string;
    accountManagerEmail: string;
    assessmentAdmin?: string;
    assessmentAdminEmail?: string;
    assessmentAdminImKey?: number;
    assessmentAdminGroup?: string;
    assessmentAdminGroupId?: number;
    start: Date | null;
    end: Date | null;
    dateRange: string;
    type: string;
    typeKey: number;
    code: string;
    networkPartner: string;
    managingLocation: string;
    managingLocationKey: number;
    deliveryLocation: string;
    languageKey?: number;
    language?: string;
    sessionFormat: string;
    sessionCode: string;
    sessionKey: number;
    hostingPlatform: string;
    hostingPlatformKey: number;
    assessmentPlatform: string;
    assessmentPlatformKey: number;
    hasCompassSku: boolean;
    status: string;
    admin?: string;
    adminGroup?: string;
    hasVenue: boolean;
    glGroup?:string;
};

export type SessionCalendarEvent = {
    programId: number;
    programCode: string;
    title: string;
    startDate: Date;
    endDate: Date;
    isOE: boolean;
    scoreDate?: Date;
    campusName: string;
    campusAbbreviation: string;
};

export type SessionCalendarRequest = {
    start: string;
    end: string;
};

export type AddAssessmentListRequest = {
    esKey: number;
    assessmentList: AssessmentListItem[];
};

/* Session Setup Dto and results */
export type AssessmentListItem = {
    esKey: number;
    bPI_Key: number;
    bPI_Seq_Num: number;
    bPIT_Key: number;
    docA_Path: string;
    cclMasterKey: number;
    assessmentType: string;
    instrumentTypeKey: number | null;
    cclMasterRaterKey: number | null;
    title: string;
    status: string;
    groupReportRequested: boolean;
    aggregateReportRequested: boolean;
    aggregateReportAvailable: boolean;
    groupReportAvailable: boolean;
    assetKey: number;
};

export type SessionProgramManager = {
    programId: number;
    individualId: number;
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    status: string;
};

export type UpdateProgramManagerResponse = {
    success: boolean;
    esKey: number;
    programManagerId?: number;
    programManagerEmail: string;
};

export type SessionSetupAssessmentsData = {
    addedAssessmentList: AssessmentListItem[];
    assessmentOptionsList: AssessmentList[];
    documentOptionsList: DocumentList[];
};

export type SessionProgramData = {
    programId: number;
    programCode: string;
    programTypeId: number;
    programCodeId: number;
    programTypeDerivedId: number;
    programTypeDerivedName: string;
    statusTypeId: number;
    statusTypeName: string;
    programName: string;
    siteKey: number;
    hotelId: number;
    hotelName: string;
    hotelUrl: string | null;
    startDate: Date | null;
    endDate: Date | null;
    preworkInvitationDate: Date;
    preworkInvitationStatus: boolean;
    surveyCompletionDate: Date;
    scoreDate: Date;
    location: string;
    hostingPlatformId: number;
    hostingPlatformName: string;
    surveyPlatformId: number;
    surveyPlatformName: string;
    programGroupTypeName: string;
    doubleRunProgramCode: string;
    reminderStatus: boolean;
    reminder1: Date | null;
    reminder2: Date | null;
    reminder3: Date | null;
    certification: boolean;
    isSelfRegistration: boolean;
    eventType: string;
    cnxCancellationPolicyF2F: number;
    cnxCancellationPolicyPhone: number;
    cnxCancellationPolicyF2FName: string;
    cnxCancellationPolicyPhoneName: string;
    cnxCoachingEvaluationSurveyNeeded: boolean;
    cornerstoneSessionId: string | number | null;
};

export type SessionKeyDates = {
    preworkInvitationDate: Date | null;
    surveyCompletionDate: Date | null;
    reminder1: Date | null;
    reminder2: Date | null;
    reminder3: Date | null;
};

export type UpdateSessionProgramDataRequest = {
    programId: number;
    reminder1: Date | null;
    reminder2: Date | null;
    reminder3: Date | null;
    scoreDate: Date | null;
    surveyCompletionDate: Date;
    preworkInvitationDate: Date;
    isSelfRegistration: boolean;
    eventType: string;
    cnxCancellationPolicyF2F: number;
    cnxCancellationPolicyPhone: number;
    cornerstoneSessionId: string | number | null;
    hotelId: number;
    hotelUrl: string | null;
    statusTypeId: number;
    startDate: Date | null;
    endDate: Date | null;
};

export type scheduleTemplate = {
    reminder1: Date | null;
    reminder2: Date | null;
    reminder3: Date | null;
    scoreDate: Date;
    surveyCompletionDate: Date;
    preworkInvitationDate: Date;
};

export type getAssetDocumentKey = {
    aI_Key: number;
    message: string;
    success: boolean;
};

/*Session setup program template data */
export type Assignment = {
    name: string;
    buildPlanItemTypeId: number;
    cclMasterId: number;
    cclMasterRaterKey: number;
    instrumentTypeKey: number;
};

export type Certification = {
    name: string;
};

export type Notification = {
    sendRemindersOnWeekend: boolean;
    reminder1DaysBeforeStartDate: number;
    reminder2DaysBeforeStartDate: number;
    reminder3DaysBeforeStartDate: number;
};

export type Schedule = {
    preWorkDateDaysBeforeStartDate: number;
    surveyCompletionDaysBeforeStartDate: number;
    scoreDateDaysBeforeStartDate: number;
};

export type ProgramTemplateList = {
    programTemplateId: number;
    id: string | number;
    version: number;
    active: boolean;
    programCodeId: number | null;
    programTypeId: number;
    languageId: number;
    regionId: number;
    name: string;
    courseId: string;
    createdDateTimeUtc: string;
    createdByUserName: string;
    modifiedDateTimeUtc: string;
    modifiedByUserName: string;
    assessmentList: Assignment[];
    certifications: Certification[];
    notification: Notification[];
    schedule: Schedule[];
};

export type AssessmentList = {
    assessmentID: string;
    assessmentName: string;
};

export type DocumentList = {
    documentID: number;
    documentName: string;
};

export type HotelList = {
    hotelID: number;
    hotelName: string;
};

export type SessionSetupData = {
    esKey: number;
    sessionProgramData: SessionProgramData;
    programTemplate: ProgramTemplateList[];
    hotelListSelect: HotelList[];
};

export type setupResponse = {
    eskey: number;
    success: boolean;
};
export type TemplateRequest = {
    eskey: number;
    programTemplateId: number;
};
/* Session Setup Dto and results End*/

// assign coaches payload types
export type CoachAssignmentEndpointPayload = {
    eskey: number;
    payload: CoachAssignmentPayload;
};

export type CoachAssignmentPayload = {
    coachAssignments: CoachAssignment[];
};

export type CoachAssignment = {
    isRemove: boolean;
    coachAssignment: AssignCoachRequest;
};

export type AssignCoachRequest = {
    coachImKey: number;
    isPrimary: boolean;
    isProposed: boolean;
    paxImKey: number;
};

// assign coaches response types
export type CoachAssignmentsResponse = {
    coachAssignmentResponses: CoachAssignmentResult[];
};

export type CoachAssignmentResult = {
    success: boolean;
    errMessage: string;
    esRemove: boolean;
    coachAssignment: SessionDetailAssignedCoach;
};

/* Custom Notification Tab */
export type customNotification = {
    language: Languages[];
    customProgramTemplateHeaders: CustomProgramTemplateHeader[];
    clavinTypeID: number;
    esKey: number;
    languageKey: number;
    status: number;
    subject: string;
    content: string;
    programs: NotificationProgramDto;
};

export type NotificationProgramDto = {
    programId: number;
    site: string;
    contactId: string;
    contactFirstName: string;
    contactLastName: string;
    groupMasterId: number;
    groupMasterName: string;
    regionId: number;
    name: string;
    statusId: number;
    statusName: string;
    derivedStatusId: number | null;
    typeId: number;
    derivedEventTypeId: number;
    derivedEventTypeName: string;
    typeName: string;
    startDate: Date;
    endDate: Date;
    budgetCode: string;
    preWorkDate: Date;
    assessmentDueDate: Date;
    buildPlanId: number;
    iASSentDate: Date;
    trainingProviderId: number;
    trainingProviderDivisionId: number;
    trainingProviderDivisionName: string;
    trainingProviderOrganizationId: number;
    trainingProviderOrganizationName: string;
    programCodeId: number;
    programCode: string;
    programCodeEventTitle: string;
    subtypeId: number;
    subtypeDescription: string;
    hostingPlatformId: number;
    hostingPlatform: string;
    compassFlag: number;
    surveyPlatformId: number;
    surveyPlatformName: string;
    clientDivisionId: number;
    clientDivisionName: string;
    clientOrganizationId: number;
    clientOrganizationName: string;
};

export type CustomProgramTemplateHeader = {
    emailTypeId: number;
    programEmailTemplateId: number;
    emailBaseTypeId: number;
    eventTypeDerivedId: number;
    emailBaseTypeName: string;
};

export type Languages = {
    languageId: number;
    name: string;
    translatedLanguageId: number;
    translatedLanguageName: string;
};

export type NotificationRequest = {
    eskey: number;
    languageId: number;
    clavinId: number;
    subject: string;
    content: string;
    status: number;
    // OE participant email preview only: the participant (first entry in the Send Participants
    // Email panel's sorted Recipient List) whose data should resolve the preview's merge tokens.
    // Omitted by Custom Notification's session-level preview.
    esiKey?: number;
};

export type NotificationMetadataRequest = {
    eskey: number;
    languageId: number;
    clavinId: number;
};

export type NotificationResponse = {
    subject: string;
    content: string;
    status: number;
    success: boolean;
};
/* End Custom Notification Tab*/

/* Send Participants Email (ad-hoc, OE) */
export type ParticipantEmailTemplate = {
    emailTypeId: number;
    description: string;
    subject: string;
    body: string;
    languageKey: number;
};

export type SendParticipantEmailRequest = {
    esiKeys: number[];
    languageKey: number;
    emailTypeId: number;
    subject: string;
    body: string;
    // Optional courtesy copies, copied on every participant's email. One plain address per element.
    cc?: string[];
};

export type ParticipantEmailRecipient = {
    esiKey: number;
    firstName: string;
    lastName: string;
    email: string;
};

export type SendParticipantEmailResult = {
    emailedCount: number;
    recipients: ParticipantEmailRecipient[];
};
/* End Send Participants Email */

/* CNX Payloads */
export type CnxNotifyCoachAssignedPayload = {
    eskey: number;
    esikey: number;
    payload: {
        assignedCoachImKey: number | null;
        removedCoachImKey: number | null;
    };
};

export type CnxNotifyCoachesProposedPayload = {
    eskey: number;
    esikey: number;
    payload: { proposedCoachesImKeys: number[]; removedCoachesImKeys: number[] };
};

export type AssignmentsByDateQueryArgs = {
    start: string;
    end: string;
};

export type AssessmentNotificationStatus = {
    eskey: number;
    payload: AssessmentNotificationStatusPayload;
};

export type AssessmentNotificationStatusPayload = {
    preworkInvitationStatus?: boolean;
    reminderStatus?: boolean;
};

export type SessionLanguage = {
    languageKey: number;
    language: string;
};

export type AvailableTransferSession = {
    esKey: number;
    sessionTitle: string;
    sessionId: string;
    start: string;
    end: string;
    surveyCompletionDate: string | null;
};

export type AvailableAssessments = {
    buildPlanKey: number;
    name: string;
    assessmentAdminGroupId: number;
};

// note the dates are strings because we don't want
//  them auto-serialized as ISO/UTC dates
export type CreateSessionRequest = {
    title: string;
    clientName: string | null;
    buildPlanKey: number;
    startDate: string | null;
    endDate: string | null;
    surveyCompletion: string;
    autoInvitationDate: string | null;
    reminderDates: (string | null)[];
};
